import { render, staticRenderFns } from "./NameAcronym.vue?vue&type=template&id=0dda33e6&scoped=true"
import script from "./NameAcronym.vue?vue&type=script&lang=js"
export * from "./NameAcronym.vue?vue&type=script&lang=js"
import style0 from "./NameAcronym.vue?vue&type=style&index=0&id=0dda33e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda33e6",
  null
  
)

export default component.exports